module.exports = __webpack_public_path__ + "static/portfolio-d705ded86c7061d5c5518550f7a7d19b.png";